import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SectionDivider } from '../components/Layout';

// ダウンロード可能なファイル（パンフレット）
const pamphletFile = {
  id: 1,
  title: 'パンフレット',
  description: '立石農園のパンフレットです。',
  filename: 'tateishi_pamphlet.pdf',
  fileUrl: '/downloads/tateishi_pamphlet.pdf',
  fileSize: '2.5MB',
  icon: '📄',
  available: true,
  hasPreview: true,
  previewImages: [
    '/images/pamphlet/page1.jpg',
    '/images/pamphlet/page2.jpg',
    '/images/pamphlet/page3.jpg',
    '/images/pamphlet/page4.jpg'
  ]
};

// 準備中の資料
const upcomingFiles = [
  {
    id: 2,
    title: '商品カタログ',
    description: 'きゅうり・さつまいもの商品カタログです。'
  },
  {
    id: 3,
    title: '申込書',
    description: '商品の申込書です。ダウンロードしてご利用いただけます。'
  }
];

export default function DownloadsPage() {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentFile, setCurrentFile] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);

  const handleDownload = (fileUrl, filename) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePreview = (file) => {
    setCurrentFile(file);
    setCurrentPage(0);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentFile(null);
    setCurrentPage(0);
  };

  const handleNextPage = () => {
    if (currentFile && currentPage < currentFile.previewImages.length - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="min-h-screen relative">

      {/* SVG区切り */}
      <SectionDivider title="downloads" />

      {/* ダウンロードセクション */}
      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-6xl mx-auto">
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">

              {/* セクションタイトル */}
              <div className="text-center mb-8 md:mb-12">
                <h1 className="heading-1 mb-4" style={{color: '#8b4513'}}>
                  資料ダウンロード
                </h1>
                <p className="body-text" style={{color: '#8b4513', opacity: 0.8}}>
                  立石農園の各種資料をダウンロードしていただけます。<br />
                  ご自由にご覧ください。
                </p>
              </div>

              {/* ファイル一覧 */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-12 px-4 md:px-0">

                {/* パンフレット (2カラム) */}
                <div
                  className="bg-white rounded-2xl shadow-sm p-4 md:p-6 transition-all duration-300 hover:shadow-lg md:col-span-2"
                  style={{border: '1px solid #e5d3b3'}}
                >
                  {/* サムネイル */}
                  <div className="mb-4 rounded-lg overflow-hidden">
                    <img
                      src={pamphletFile.previewImages[0]}
                      alt={`${pamphletFile.title}サムネイル`}
                      className="w-full h-auto object-cover"
                      style={{maxHeight: '300px'}}
                    />
                  </div>

                  {/* タイトル */}
                  <h3 className="heading-3 mb-3 text-center" style={{color: '#8b4513'}}>
                    {pamphletFile.title}
                  </h3>

                  {/* 説明 */}
                  <p className="body-text mb-4 text-center" style={{color: '#8b4513', opacity: 0.8}}>
                    {pamphletFile.description}
                  </p>

                  {/* ファイルサイズ */}
                  <p className="text-sm mb-4 text-center" style={{color: '#8b4513', opacity: 0.6}}>
                    ファイルサイズ: {pamphletFile.fileSize}
                  </p>

                  {/* ボタン */}
                  <div className="space-y-2">
                    {/* 閲覧ボタン */}
                    <button
                      onClick={() => handlePreview(pamphletFile)}
                      className="w-full px-6 md:px-8 py-3 md:py-4 text-base md:text-lg font-medium rounded-lg transition-all duration-300"
                      style={{
                        color: '#8b4513',
                        backgroundColor: '#fff',
                        border: '2px solid #8b4513',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 69, 19, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      閲覧する
                    </button>
                    {/* ダウンロードボタン */}
                    <button
                      onClick={() => handleDownload(pamphletFile.fileUrl, pamphletFile.filename)}
                      className="w-full px-6 md:px-8 py-3 md:py-4 text-base md:text-lg font-medium rounded-lg transition-all duration-300"
                      style={{
                        color: '#fff',
                        backgroundColor: '#8b4513',
                        border: '2px solid #8b4513',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 69, 19, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      ダウンロード
                    </button>
                  </div>
                </div>

                {/* その他の資料（準備中） (1カラム) */}
                <div
                  className="bg-white rounded-2xl shadow-sm p-4 md:p-6 transition-all duration-300 md:col-span-1"
                  style={{border: '1px solid #e5d3b3'}}
                >
                  {/* タイトル */}
                  <h3 className="heading-3 mb-4 text-center" style={{color: '#8b4513'}}>
                    その他の資料（準備中）
                  </h3>

                  {/* 資料リスト */}
                  <div className="space-y-4">
                    {upcomingFiles.map(file => (
                      <div key={file.id} className="border-b border-orange-200 pb-4 last:border-b-0 last:pb-0">
                        <h4 className="font-bold mb-2 text-center" style={{color: '#8b4513'}}>
                          {file.title}
                        </h4>
                        <p className="body-text text-sm mb-3 text-center" style={{color: '#8b4513', opacity: 0.8}}>
                          {file.description}
                        </p>
                        <div
                          className="w-full px-4 py-2 text-sm font-medium rounded-lg text-center"
                          style={{
                            color: '#8b4513',
                            backgroundColor: '#f3f4f6',
                            border: '2px solid #e5d3b3',
                            opacity: 0.6,
                            cursor: 'not-allowed'
                          }}
                        >
                          準備中
                        </div>
                      </div>
                    ))}

                    {/* 購入・問い合わせ */}
                    <div className="pt-4 space-y-6">
                      {/* 個人のお客様 */}
                      <div>
                        <h4 className="font-bold mb-2 text-center" style={{color: '#8b4513'}}>
                          個人のお客様
                        </h4>
                        <p className="text-xs mb-3 text-center" style={{color: '#8b4513', opacity: 0.8}}>
                          立石農園の農作物は以下のサイトからご購入いただけます
                        </p>
                        <div className="space-y-2">
                          <a
                            href="https://www.tabechoku.com/producers/3078345?srsltid=AfmBOorXuP8OB-ehEl8b8-qLtXW0qcL4L0KjoOdCkAqzEfyPN5Yo2oGy"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-bold text-xs text-center transition-colors"
                          >
                            食べチョクで購入
                          </a>
                          <a
                            href="https://jp.mercari.com/user/profile/819884723"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg font-bold text-xs text-center transition-colors"
                          >
                            メルカリで購入
                          </a>
                        </div>
                      </div>

                      {/* 業者のお客様 */}
                      <div className="border-t border-orange-200 pt-4">
                        <h4 className="font-bold mb-2 text-center" style={{color: '#8b4513'}}>
                          業者のお客様
                        </h4>
                        <p className="text-xs mb-3 text-center" style={{color: '#8b4513', opacity: 0.8}}>
                          卸売・業務用のご注文は、お問い合わせフォームよりご連絡ください
                        </p>
                        <button
                          onClick={() => navigate('/contact')}
                          className="w-full bg-orange-800 hover:bg-orange-900 text-white px-4 py-2 rounded-lg font-bold text-xs text-center transition-colors"
                          style={{backgroundColor: '#8b4513'}}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#6d3610'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#8b4513'}
                        >
                          お問い合わせはこちら
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              {/* 注意事項 */}
              <div className="bg-orange-50 rounded-xl p-4 md:p-6 mb-8 text-center mx-4 md:mx-0" style={{border: '1px solid #fed7aa'}}>
                <h3 className="heading-3 mb-3" style={{color: '#8b4513'}}>
                  ご利用にあたって
                </h3>
                <ul className="space-y-2 body-text inline-block text-left text-sm md:text-base" style={{color: '#8b4513', opacity: 0.8}}>
                  <li>• PDFファイルをご覧いただくには、Adobe Readerが必要です。</li>
                  <li>• 資料の内容は予告なく変更される場合がございます。</li>
                  <li>• 資料の無断転載・複製はご遠慮ください。</li>
                  <li>• ご不明な点がございましたら、お気軽にお問い合わせください。</li>
                </ul>
              </div>

            </div>
          </section>
        </div>
      </div>

      {/* プレビューモーダル */}
      {isModalOpen && currentFile && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
          onClick={handleCloseModal}
        >
          <div
            className="relative max-w-5xl w-full mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            {/* 閉じるボタン */}
            <button
              onClick={handleCloseModal}
              className="absolute -top-12 right-0 text-white text-4xl font-bold hover:text-gray-300 transition-colors z-10"
              style={{lineHeight: 1}}
            >
              ×
            </button>

            {/* タイトルとページ番号 */}
            <div className="text-center mb-4">
              <h3 className="text-white text-lg md:text-2xl font-bold mb-2">{currentFile.title}</h3>
              <p className="text-white text-base md:text-lg">
                {currentPage + 1} / {currentFile.previewImages.length}
              </p>
            </div>

            {/* 画像表示エリア */}
            <div className="relative bg-white rounded-lg overflow-hidden">
              <img
                src={currentFile.previewImages[currentPage]}
                alt={`${currentFile.title} - ページ ${currentPage + 1}`}
                className="w-full h-auto"
                style={{maxHeight: '70vh', objectFit: 'contain'}}
              />

              {/* 前へボタン */}
              {currentPage > 0 && (
                <button
                  onClick={handlePrevPage}
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-3 shadow-lg transition-all"
                  style={{color: '#8b4513'}}
                >
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
              )}

              {/* 次へボタン */}
              {currentPage < currentFile.previewImages.length - 1 && (
                <button
                  onClick={handleNextPage}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-3 shadow-lg transition-all"
                  style={{color: '#8b4513'}}
                >
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              )}
            </div>

            {/* ダウンロードボタン */}
            <div className="text-center mt-4">
              <button
                onClick={() => handleDownload(currentFile.fileUrl, currentFile.filename)}
                className="px-6 md:px-8 py-3 md:py-4 text-base md:text-lg font-medium rounded-lg transition-all duration-300 shadow-lg"
                style={{
                  color: '#fff',
                  backgroundColor: '#8b4513',
                  border: '2px solid #8b4513',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 16px rgba(139, 69, 19, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 69, 19, 0.2)';
                }}
              >
                PDFをダウンロード
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
